import React from 'react'
import ApiLogs from '../components/ApiLogs'

const ApiLogsPage = () => {
  return (
    <div><ApiLogs/></div>
  )
}

export default ApiLogsPage